<div class="cargando" *ngIf="undefined === indemnizaciones">
    <p>Cargando<span>.</span><span>.</span><span>.</span></p>
</div>

<div class="empty" *ngIf="indemnizaciones && indemnizaciones.length === 0">
    <p>No hay indemnizaciones relacionadas con este expediente.</p>
</div>

<div class="indem-list" *ngIf="indemnizaciones && indemnizaciones.length > 0">

    <div class="indem-row" *ngFor="let i of indemnizaciones">

        <div class="tile">
            <div class="tile-icon">
                <svg viewBox="0 0 32 32" fill="none" stroke="#ffffff" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <circle cx="12" cy="11" r="4"/>
                    <path d="M4 26c0-4 4-7 8-7s8 3 8 7"/>
                    <circle cx="22" cy="9" r="3"/>
                    <path d="M28 22c0-3 -3-5 -6-5"/>
                </svg>
            </div>
            <div class="tile-text">
                <p class="tile-label">Nombre</p>
                <p class="tile-value">{{ i.paymentName }}</p>
            </div>
        </div>

        <div class="tile">
            <div class="tile-icon">
                <svg viewBox="0 0 32 32" fill="none" stroke="#ffffff" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <rect x="4" y="7" width="24" height="18" rx="3"/>
                    <path d="M4 13h24"/>
                    <path d="M8 20h4"/>
                </svg>
            </div>
            <div class="tile-text">
                <p class="tile-label">Nº de cuenta</p>
                <p class="tile-value">{{ i.paymentcountNumber }}</p>
            </div>
        </div>

        <div class="tile">
            <div class="tile-icon">
                <svg viewBox="0 0 32 32" fill="none" stroke="#ffffff" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <rect x="5" y="5" width="22" height="22" rx="3"/>
                    <path d="M19 12h-5a2 2 0 0 0 0 4h4a2 2 0 0 1 0 4h-5"/>
                    <path d="M16 10v2M16 20v2"/>
                </svg>
            </div>
            <div class="tile-text">
                <p class="tile-label">Importe</p>
                <p class="tile-value">{{ i.price }} €</p>
            </div>
        </div>

        <div class="tile">
            <div class="tile-icon">
                <svg viewBox="0 0 32 32" fill="none" stroke="#ffffff" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <rect x="5" y="7" width="22" height="20" rx="3"/>
                    <path d="M5 13h22"/>
                    <path d="M11 4v6M21 4v6"/>
                </svg>
            </div>
            <div class="tile-text">
                <p class="tile-label">Fecha</p>
                <p class="tile-value">{{ i.date | date: 'dd/MM/yyyy' }}</p>
            </div>
        </div>

    </div>

</div>
